import { compose, map, prop, propOr, uniq } from 'ramda';

import { compact, path } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { toImage } from '../../fields/image';
import { toExpertiseType } from '../../mapping/expertise';
import { documentEntity } from './internal';

const getImage = path('profil_picture.0.image_src');

const getImageSrc = compose(prop('url'), getImage);

const getThumbnail = compose(prop('thumbnail'), toImage, getImage);

const extractExpertises = compose(
  compact,
  uniq,
  map(compose(toExpertiseType, prop('expertise'))),
  propOr([], 'expertises')
);

const processContactInfo = (data) =>
  compact({
    type: DocumentType.CONTACT,
    lastname: prop('lastname', data),
    name: prop('name', data),
    email: prop('email', data),
    twitter: prop('twitter', data),
    linkedin: prop('linkedin', data),
    job: prop('job_position', data),
    address: prop('address', data),
    description: prop('description', data),
    picture: getImageSrc(data),
    thumbnail: getThumbnail(data),
    expertises: extractExpertises(data),
  });

export const ContactEntity = documentEntity(DocumentType.CONTACT, {
  processStrategy: (doc) => processContactInfo(prop('data', doc)),
});
